/**
 * Форматирует номер телефона в формат: `+7 (999) 999 99 99`
 * @param rawPhone - Строка или число с "сырым" номером (например, 79991234567)
 * @returns Отформатированная строка (например, "+7 (999) 123 45 67")
 */

export const formatPhoneNumber = (rawPhone?: string | number): string => {
  if (!rawPhone) {
    return '';
  }

  const cleaned = String(rawPhone).replace(/\D/g, '').trim();
  if (!cleaned) {
    return '';
  }

  if (/^[78]\d{10}$/.test(cleaned)) {
    const [, code, part1, part2, part3] =
      cleaned.match(/^[78](\d{3})(\d{3})(\d{2})(\d{2})$/) || [];
    return `+7 (${code}) ${part1} ${part2} ${part3}`;
  }

  return `+${cleaned}`;
};
